import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Link from "../../../../elements/Link";

var ListOfLinksLink = function ListOfLinksLink(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var getClassName = getClassNameFactory(ListOfLinksLink.displayName);
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(Link, props, children));
};

ListOfLinksLink.displayName = "ListOfLinks.Link";
ListOfLinksLink.propTypes = {
  /**
   * Title text.
   */
  children: PropTypes.node.isRequired,

  /**
   * URL for the link.
   */
  href: PropTypes.string,

  /**
   * Type of link.
   */
  type: PropTypes.oneOf(Object.values(Link.types)),

  /**
   * Enable block behaviour.
   */
  block: PropTypes.bool,

  /**
   * Open link in new tab/window.
   */
  newWindow: PropTypes.bool
};
export default ListOfLinksLink;